/* BELLY DESTROYER offer selector bridge — syncs offer radios to product form variant */
(function () {
  function initSelector(sel) {
    var cfg;
    try { cfg = JSON.parse(sel.getAttribute('data-offer-config')); } catch (e) { return; }
    if (!cfg || !cfg.offers) return;

    var sectionEl = sel.closest('.shopify-section') || document;

    function setVariant(variantId) {
      var inputs = sectionEl.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      inputs.forEach(function (inp) {
        inp.value = variantId;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    function updateMainPrice(option) {
      var rowPrice = option.querySelector('.bv5-offer-selector__price');
      var rowCompare = option.querySelector('.bv5-offer-selector__compare');
      /* enhanced price block */
      var enCur = sectionEl.querySelector('.bv5-enhanced-price__current');
      var enCmp = sectionEl.querySelector('.bv5-enhanced-price__compare');
      if (enCur && rowPrice) enCur.textContent = rowPrice.textContent.trim();
      if (enCmp && rowCompare) enCmp.textContent = rowCompare.textContent.trim();
      /* dawn price block fallback */
      var priceEl = sectionEl.querySelector('.price-item--sale') || sectionEl.querySelector('.price-item--regular');
      var compareEl = sectionEl.querySelector('.price__sale s.price-item--regular') || sectionEl.querySelector('s.price-item--regular');
      if (priceEl && rowPrice) priceEl.textContent = rowPrice.textContent.trim();
      if (compareEl && rowCompare) compareEl.textContent = rowCompare.textContent.trim();
    }

    sel.addEventListener('change', function (ev) {
      var radio = ev.target;
      if (!radio.classList.contains('bv5-offer-selector__radio')) return;
      var offer = null;
      for (var i = 0; i < cfg.offers.length; i++) {
        if (cfg.offers[i].offer === radio.value) { offer = cfg.offers[i]; break; }
      }
      if (!offer) return;
      sel.querySelectorAll('.bv5-offer-selector__option').forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.contains(radio));
      });
      setVariant(offer.variantId);
      var option = sel.querySelector('.bv5-offer-selector__option[data-offer="' + radio.value + '"]');
      if (option) updateMainPrice(option);
      sel.dispatchEvent(new CustomEvent('offer:change', { bubbles: true, detail: offer }));
    });

    // initialize to offer 1
    var checked = sel.querySelector('.bv5-offer-selector__radio:checked');
    if (checked) {
      var o0 = null;
      for (var j = 0; j < cfg.offers.length; j++) { if (cfg.offers[j].offer === checked.value) o0 = cfg.offers[j]; }
      if (o0) setVariant(o0.variantId);
    }
  }

  function boot() { document.querySelectorAll('.bv5-offer-selector').forEach(initSelector); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
